/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */
define('modules/jquery-plugins',["jquery"], function($) {
    
    //Extensions to the global jquery object
    $.extend({
        //parse some html and return the first node it created.
        parseHTMLNode: function(html) {
            return $($.parseHTML($.trim(html))[0]);
        }
    });

    //Extends jquery with some helper functions
    $.fn.extend({
        /**
         * Returns the data- attribute of the closest element that has such attirbute.
         *
         * @param name
         * @returns {*}
         */
        closestData: function(name){
            var attrName = 'data-' + name;
            var closest = $(this).closest('*['+ attrName + ']');

            if (closest.length > 0)
                return closest.attr(attrName);

            return undefined;
        },
        /**
         * Takes a form and returns an hash where keys are input elements names
         * and values are input elements values
         *
         * @returns {*}
         */
        toHash: function() {
            var array = $(this).serializeArray();
            var hash = {};

            for (var i = 0; i < array.length; i++) {
                hash[array[i].name] = array[i].value;
            }

            return hash;
        },

        /**
         * Adds and removes highlight class, making css transition start
         */
        highlight: function() {
            $(this)
                .addClass('highlight')
                .addClass('highlightable')
                .focus()
                .removeClass('highlight').focus()
            ;

            return $(this);
        },

        /**
         * Subsitutes the text 0of the element with a text that indicates that something is loading, or
         * put a data-isloading=1 attribute on the element
         *
         * @param mode Can be either 'text' or 'notext'
         * @param label Optional. if none given, it tries to use a data-loading-text attribute.
         * If there is no such attribute, 'Loading...' label is used
         */
        setLoading: function(mode, label) {
            label = label || ($(this).data('loading-text') || 'Loading...');
            mode = mode || 'text';

            switch (mode) {
                case 'text':
                    $(this)
                        .data('old-text', $(this).html())
                        .html(label)
                    ;
                    break;
                default:
                    $(this).attr('data-isloading', '1');
            }


            return $(this);
        },

        /**
         * Restores the text of an item previously modified with "setLoading"
         *
         * @param mode Can be either 'text' or 'notext'
         */
        unsetLoading: function(mode) {
            mode = mode || 'text';
            switch (mode) {
                case 'text':
                    if ($(this).data('old-text')) {
                        $(this)
                            .html($(this).data('old-text'))
                            .removeData('old-text')
                        ;
                    }
                    break;
                default:
                    $(this).removeAttr('data-isloading');
            }

            return $(this);
        },

        /**
         * Toggles loading state for an element
         */
        toggleLoading: function() {
            if ($(this).data('old-text')) {
                $(this).unsetLoading();
            } else {
                $(this).setLoading();
            }
        },

        /**
         * Increase the text value of elements
         */
        increase: function(increment) {
            increment = increment || 1;

            $(this).each(function(){
                var previous = parseInt($(this).text());
                $(this).text(previous + increment);
            });
        },

        /**
         * scroll the page to the current element
         *
         * @param speed (otpional). The speed of the animation. Default is 'slow'
         */
        scrollTo: function(speed) {
            $('html,body').animate({scrollTop: $(this).offset().top}, speed || 'slow');
        }

    });
});
